import { useTranslations } from 'next-intl'

import { useSearchFilterStore } from '@/entities/map'
import { useFilter } from '@/features/room-filter'
import { Button, Dialog } from '@/shared/ui'

export const ApplyButton = () => {
  const t = useTranslations('filter')

  const { filter } = useFilter()
  const actions = useSearchFilterStore(state => state.actions)

  const handleClick = () => {
    actions.update(filter)
  }

  return (
    <Dialog.Close asChild onClick={handleClick}>
      <Button size="large" fullWidth>
        {t('button.apply')}
      </Button>
    </Dialog.Close>
  )
}
